import { PaletteMode } from '@mui/material';
import { GetThemeOptions } from '../../theme';
import { blue, ChronosphereColorPalette } from '../colors';
import { buildPaletteForMode, type Token } from '../panw-palette/token-metadata';

const secondaryColorTokens = [
  { propertyPath: 'main', tokenName: '--secondary-color-main' },
  { propertyPath: 'highContrast', tokenName: '--secondary-color-high-contrast' },
  { propertyPath: 'lowContrast', tokenName: '--secondary-color-low-contrast' },
] satisfies Token[];

export const secondaryColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return buildPaletteForMode<ChronosphereColorPalette>(secondaryColorTokens, mode);
  }
  return mode === 'light'
    ? {
        main: blue[600],
        highContrast: blue[800],
        lowContrast: blue[150],
      }
    : {
        main: blue[500],
        highContrast: blue[300],
        lowContrast: blue[700],
      };
};
